import get from './get';

export default (state, sliceId, nextState) => ({
  ...state,
  [sliceId]: {
    ...get(state, [sliceId]),
    ...nextState,
  },
});
